/**
 * Notice: These constants are mirrored in PHP MainController. Any changes should be reflected there as well.
 */
export const PAGE_TYPE_ACCOUNT = "account";
export const PAGE_TYPE_ARTICLE = "article";
export const PAGE_TYPE_CAMPAIGN = "campaign";
export const PAGE_TYPE_CONTACT = "contact";
export const PAGE_TYPE_DEALS = "deals";
export const PAGE_TYPE_FAVORITES = "favorites";
export const PAGE_TYPE_HOME = "home";
export const PAGE_TYPE_HOTEL = "hotel";
export const PAGE_TYPE_NEWSLETTER = "newsletter";
export const PAGE_TYPE_NEWSLETTER_CONTEST_TERMS = "newsletter-contest-terms";
export const PAGE_TYPE_NEWSLETTER_SUBSCRIPTION = "newsletter-subscription";
export const PAGE_TYPE_NEWSLETTER_UNSUBSCRIPTION = "newsletter-unsubscription";
export const PAGE_TYPE_NOT_FOUND = "not-found";
export const PAGE_TYPE_OTHER = "other";
export const PAGE_TYPE_SEARCH = "search";

export const pageType = document.documentElement.getAttribute("data-page-type");

export const pageTypeName =
	{
		[PAGE_TYPE_DEALS]: "Deals",
		[PAGE_TYPE_FAVORITES]: "Merkliste",
		[PAGE_TYPE_HOME]: "Home",
		[PAGE_TYPE_NEWSLETTER_SUBSCRIPTION]: "Newsletter-Anmeldung",
		[PAGE_TYPE_NEWSLETTER_UNSUBSCRIPTION]: "Newsletter-Abmeldung",
		[PAGE_TYPE_NOT_FOUND]: "404",
		[PAGE_TYPE_SEARCH]: "Suche",
	}[pageType] || pageType;
